export enum ContentCollectionListEnum {
	MY_HOSPITALIZATION = 'minhainternacao',
	YOUTUBE = 'youtube',
	YOUTUBE_HIGHLIGHT = 'youtube-destaque',
	BLOG = 'blog',
	BLOG_HIGHLIGHT = 'blog-destaque',
}

export type ContentList = {
	URL: string;
	articleId: number;
	collection: string;
	title: string;
	campos: Campos;
	categorias: Categoria[];
};

export interface Campos {
	imagem_alt?: string;
	conteudo?: string;
	minhaInternacao?: MinhaInternacao;
	cards?: Cards;
	SeparadorSumario?: SeparadorSumario;
	imagem_name?: string;
	imagem?: string;
	titulo?: string;
	dataPublicacao?: string;
	imagem_title?: string;
	descricao?: string;
	imgDesktopBeneficiario?: string;
	imgDesktopModalBeneficiario_name?: string;
	imgDesktopModalBeneficiario?: string;
	imgMobileModalBeneficiario?: string;
	imgMobileModalBeneficiario_name?: string;
	imgMobileBeneficiario?: string;
	imgMobileBeneficiario_alt?: string;
	imgMobileModalBeneficiario_title?: string;
	imgDesktopBeneficiario_name?: string;
	imgDesktopModalBeneficiario_title?: string;
	imgDesktopBeneficiario_title?: string;
	imgDesktopBeneficiario_alt?: string;
	imgDesktopModalBeneficiario_alt?: string;
	imgMobileModalBeneficiario_alt?: string;
	imgMobileBeneficiario_name?: string;
	imgMobileBeneficiario_title?: string;
	imagemCapaDesktop_title?: string;
	imagemCapaMobile_name?: string;
	descricaoVideo?: string;
	imagemCapaDesktop_alt?: string;
	linkVideoYoutube?: LinkVideoYoutube;
	tituloVideo?: string;
	imagemCapaMobile_title?: string;
	imagemCapaDesktop_name?: string;
	dataPublicacaoVideoYoutube?: string;
	imagemCapaMobile_alt?: string;
	imagemCapaDesktop?: string;
	imagemCapaMobile?: string;
}

export interface MinhaInternacao {
	bannerApp_alt: string;
	exibirConteudo: string;
	bannerPortal_name: string;
	bannerPortal: string;
	bannerApp_title: string;
	bannerApp_name: string;
	bannerPortal_title: string;
	bannerPortal_alt: string;
	bannerApp: string;
}

export interface Cards {
	urlInterna?: string;
	imagemCard_title?: string;
	imagemCard?: string;
	txtBtn?: string;
}

export interface SeparadorSumario {
	TituloDaSecao: TituloDaSecao;
	SeparadorResponsavel: SeparadorResponsavel;
	SeparadorReferencia: SeparadorReferencia;
}

export interface TituloDaSecao {
	_content?: string;
	ConteudoDaSecao?: string;
}

export interface SeparadorResponsavel {
	TituloAreaResponsavel: TituloAreaResponsavel;
}

export interface TituloAreaResponsavel {
	ConteudoAreaResponsavel?: string;
	_content?: string;
}

export interface SeparadorReferencia {
	TituloDaReferencia: TituloDaReferencia;
}

export interface TituloDaReferencia {
	_content?: string;
	ConteudoDaReferencia?: string;
}

export interface LinkVideoYoutube {
	descricaoLinkYoutube: string;
	_content: string;
}

export interface Categoria {
	titulo: string;
	nome: string;
	id: string;
	url: string;
}

export type PostContentParams = {
	operadora: string;
	lista_colection: ContentCollectionListEnum[];
	numero_item: number;
	signal?: AbortSignal;
};

export type PostContentModel = {
	listaConteudos: ContentList[];
	totalItens: number;
	operadora: string;
	timestamp: string;
};

export interface PostContent {
	post: (params: PostContentParams) => Promise<PostContentModel>;
}
